import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "layout/BgTransformer";
import PixelationLayer from "layout/PixelationLayer";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import {useSetting} from "contexts/setting";
import {useEdits} from "contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {checkIfIDE} from "data/products/index";
import {checkProductInText} from "libs/utils";
import {useLogoUrl} from "../../../hooks/useLogoUrl";

const Wallpaper1 = ({id, zoom}) => {
  const {product, type, channel} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {productNames} = useEdits();

  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const logoSrc = useLogoUrl(id);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});

  return (
    <div
      id={id}
      className={cn("template", product.value, "wallpaper-1")}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <header className="template-header">
            <div className={logoClass}>
              <img src={logoSrc} alt="logo" />
            </div>
            <div className="splitter">|</div>
            <div className="product-name">
              <ContentEditable id={id} text={productName} />
            </div>
          </header>
        </div>
      </div>
    </div>
  );
};

export default Wallpaper1;
